import * as actionTypes from '../types/fieldsOrder';

export function getFieldsOrder(payload) {
  return {
    type: actionTypes.GET_FIELDS_ORDER,
    payload
  };
}

export function getFieldsOrderSuccess(payload) {
  return {
    type: actionTypes.GET_FIELDS_ORDER_SUCCESS,
    payload
  };
}

export function getFieldsOrderFail(payload) {
  return {
    type: actionTypes.GET_FIELDS_ORDER_FAIL,
    payload
  };
}

export function saveFieldsOrder(payload) {
  return {
    type: actionTypes.SAVE_FIELDS_ORDER,
    payload
  };
}

export function saveFieldsOrderSuccess(payload) {
  return {
    type: actionTypes.SAVE_FIELDS_ORDER_SUCCESS,
    payload
  };
}
export function saveFieldsOrderFail(payload) {
  return {
    type: actionTypes.SAVE_FIELDS_ORDER_FAIL,
    payload
  };
}
export function fieldsOrderInitialState() {
  return {
    type: actionTypes.FIELDS_ORDER_INITIAL_STATE
  };
}
